import { loadSignIn, signInAction } from '@/route-handlers/sign-in';
import WaitingIndicatorCircle from '@ui/waiting-indicator-circle/waiting-indicator-circle';
export { loader } from '@/route-handlers/sign-in';
export const clientLoader = Object.assign(loadSignIn, { hydrate: true });
export const clientAction = signInAction;
export { default } from '@/pages/sign-in';

export function HydrateFallback() {
  return (
    <div className="flex-center padding-40">
      <WaitingIndicatorCircle fill={'primary'} size={40} />
    </div>
  );
}
